import type {
	CustomizableMenuItemData,
	HasMenuIdAndVisible,
	NavItemConfigInternal,
} from '../../types';

export function extendWithCustomizationOptions(
	customizationData: HasMenuIdAndVisible[],
	items: Record<string, NavItemConfigInternal>,
): CustomizableMenuItemData[] {
	return customizationData.map((item) => {
		const itemConfig = items[item.menuId];
		if (!itemConfig) {
			return item;
		}

		return {
			...item,
			isNotCustomizable: itemConfig.isReorderable === false,
			isNotToggleable: itemConfig.isHideable === false,
		};
	});
}
